export const UP_DOWN_CLASSES_WEB = /** @type {const}*/({
  1: 'bto-sb-odd-up-2',
  2: 'bto-sb-odd-dw-2',
});